import React, { forwardRef } from 'react';
import { Calendar } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../../Icon';
import styles from './index.module.scss';
var IconLeft = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var accessibilityLabel = _ref.accessibilityLabel,
      disabled = _ref.disabled,
      inline = _ref.inline,
      onClick = _ref.onClick;

  if (inline) {
    return /*#__PURE__*/React.createElement(Icon, {
      "aria-hidden": "true",
      as: Calendar
    });
  }

  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    className: styles.root,
    onClick: onClick,
    disabled: disabled,
    "aria-label": accessibilityLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    as: Calendar
  }));
});
IconLeft.defaultProps = {
  accessibilityLabel: '',
  disabled: false,
  inline: false
};
export default IconLeft;